import i18n from 'i18next'
import { useTranslation } from 'react-i18next'

const LANGUAGE_STORAGE_KEY = 'appLanguage'

export type AppLanguage = 'en' | 'th'

export function useLanguage() {
  const { i18n: i18nInstance } = useTranslation()

  const language = i18nInstance.language as AppLanguage

  const setLanguage = (lang: AppLanguage) => {
    void i18n.changeLanguage(lang)
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lang)
  }

  const toggleLanguage = () => {
    const next: AppLanguage = language === 'en' ? 'th' : 'en'
    setLanguage(next)
  }

  return { language, setLanguage, toggleLanguage }
}
